"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const SearchInput = ({ search, setSearch }) => ((0, jsx_runtime_1.jsx)(material_1.TextField, { placeholder: "Search...", size: "small", value: search, onChange: (e) => setSearch(e.target.value), variant: "outlined", sx: {
        mb: 2,
        borderRadius: "8px",
        backgroundColor: "#fff",
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            fontSize: "0.875rem",
            paddingY: "4px",
        },
    } }));
exports.default = SearchInput;
